export const serviceList = [
  {
    name: '教练认证',
    items: [
      {
        name: '教练认证',
        description: '一次投入，终身受益，为组织培育教练文化，以业务为导向，培养教练型领导者',
        cover: require('../images/service_coach.png')
      },
      {
        name: '讲师认证',
        description: '历经10年的迭代优化、持续改进，为企业认证讲师300+',
        cover: require('../images/service_lecturer.png')
      }
    ]
  },
  {
    name: '培训课程',
    items: [
      {
        name: '成长路径图',
        description: '精选10门课程，形成帮助企业建设领导力梯队的培训体系',
        cover: require('../images/service_roadmap.png')
      },
      {
        name: '进阶课程',
        description: '线下课程+线上辅导，强化训练，快速掌握教练技术',
        cover: require('../images/service_advanced.png')
      }
    ]
  },
  {
    name: '银行体系',
    items: [
      {
        name: '业务发展',
        description: '服务礼仪、营销技巧、金融专业等基于业务发展相关的各类培训课程，促进业务发展',
        cover: require('../images/service_business.png')
      },
      {
        name: '人才发展',
        description: '帮助员工发挥自己的优势，让员工的能力得到更聚焦更清晰的发展',
        cover: require('../images/service_talent.png')
      },
      {
        name: '行业信息',
        description: '宏观经济与热点信息解读、人工智能时代运营管理创新',
        cover: require('../images/service_industry.png')
      }
    ]
  },
  {
    name: '在线服务',
    items: [
      {
        name: '智能教练',
        description: '基于 AI 和企业教练技术，帮助员工更好的达成业务目标',
        cover: require('../images/service_intelligence.png')
      },
      {
        name: '一对一教练',
        description: '运用线上一对一的教练对话技术帮助企业达成目标',
        cover: require('../images/service_one_to_one.png')
      }
    ]
  }
]